module.exports = __webpack_public_path__ + "static/img/exit_full_screen.f7e0b24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/exit_full_screen.png
// module id = G8Fs
// module chunks = 1